import Instance from "../../../../Axios";

// New Actions for the app

const GetCredAcompanhanteById = (id) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/acompanhantes/${id}`)
    .then(({ data }) => {
      dispatch({ type: "GET_CRED_ACOMPANHANTE_BY_ID", payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredAcompanhanteById;